import React from 'react';

import type { SideNavs } from '../../types';

import styles from './SideBar.scss';

interface Props {
  title: React.ReactNode;
  sideNavs: SideNavs[];
  categoryId?: string;
}

const SideBar: React.FC<Props> = ({ title, sideNavs, categoryId }) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <ul className={styles.list}>
      {sideNavs.map(({ id, element }, index) => (
        <li key={index} className={id === categoryId ? styles.highlight : 'none'}>
          {element}
        </li>
      ))}
    </ul>
  </div>
);

export default SideBar;
